/**
 * EventTagService
 * Events hub Stage 1B tags: source tags (read-only, from Planning Center) and manual CCMS tags.
 * Route: events/api/events/tags (Admin role OR Event.View to read, Event.Tag.Manage to write)
 */
import { BaseService } from '../base/BaseService';
import { unwrapEventsResponse as unwrap } from './unwrapEventsResponse';
export class EventTagService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EventTagService.DEFAULT_SERVICE_PATH,
            basePath: EventTagService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/events/tags?sourceId&search (Event.View). Grouped by tag group, with event counts. */
    async list(query = {}) {
        const res = await this.listRaw(query);
        return res.data ?? [];
    }
    listRaw(query = {}) {
        return this.http.get(this.buildUrlWithParams(undefined, { sourceId: query.sourceId, search: query.search?.trim() || undefined }));
    }
    /** POST api/events/tags (Event.Tag.Manage). Creates a manual CCMS tag (source 1). */
    async create(request) {
        return unwrap(await this.createRaw(request), 'Could not create the tag');
    }
    createRaw(request) {
        return this.http.post(this.buildUrl(), request);
    }
    /** PUT api/events/tags/{tagId} (Event.Tag.Manage). Manual tags only; source tags are read-only. */
    async update(tagId, request) {
        return unwrap(await this.updateRaw(tagId, request), `Could not update tag ${tagId}`);
    }
    updateRaw(tagId, request) {
        return this.http.put(this.buildUrl(String(tagId)), request);
    }
}
EventTagService.DEFAULT_SERVICE_PATH = 'events';
EventTagService.BASE_PATH = 'api/events/tags';
//# sourceMappingURL=EventTagService.js.map